import {
  LineOfCreditPaymentDetailSuccess,
  Query,
  Typenames,
} from '@varo/graphql-schema-types';
import FetchLineOfCreditPaymentDetails from 'services/graphql/queries/FetchLineOfCreditPaymentDetails';
import { AnyVariables, CombinedError, useQuery } from 'urql';

interface LineOfCreditPaymentDetails {
  fetching: boolean;
  refetch: () => void;
  error?: CombinedError;
  serializedData?: LineOfCreditPaymentDetailSuccess;
}

const useFetchLineOfCreditPaymentDetails = (): LineOfCreditPaymentDetails => {
  const [response, refetch] = useQuery<Query, AnyVariables>({
    query: FetchLineOfCreditPaymentDetails,
    requestPolicy: 'network-only',
  });

  const { data, fetching, error } = response;

  const serializedData =
    data?.lineOfCreditManualPaymentDetails.__typename ===
    Typenames.LineOfCreditPaymentDetailSuccess
      ? data.lineOfCreditManualPaymentDetails
      : undefined;

  return {
    serializedData,
    fetching: fetching,
    error: error,
    refetch,
  };
};

export default useFetchLineOfCreditPaymentDetails;
